// Section Header

export default function SectionHeader({
  eyebrow,
  title,
  accent,
  description,
  align = "center",
}) {
  const alignmentClass = align === "left" ? "text-left" : "text-center mx-auto";

  return (
    <div className={`max-w-3xl ${alignmentClass}`}>
      {eyebrow && (
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.5em] text-amber-flame-500">
          {eyebrow}
        </p>
      )}

      <h2 className="font-display text-4xl font-bold leading-tight text-white md:text-6xl">
        {title}{" "}
        {accent && (
          <span className="italic text-burnt-tangerine-500">{accent}</span>
        )}
      </h2>

      {description && (
        <p className="mt-5 text-sm leading-7 text-slate-300 md:text-base">
          {description}
        </p>
      )}
    </div>
  );
}